// extracted by mini-css-extract-plugin
export default {"VolumeSelector":"VolumeSelector_VolumeSelector__825zw"};